module.exports = ".ant-menu-item a {\n  color: rgba(255, 255, 255, 0.67);\n}\n.dw-non-icon {\n  margin-right: 5px;\n}\n"